// extracted by mini-css-extract-plugin
export default {"animationOuter":"Loading_animationOuter__hdPI9","animate":"Loading_animate__HqCzq"};